
import { mapActions } from "vuex";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import Loading from "@/components/Loading";

export default {
  name: "table-app",
  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      storageName: null,
      sortOptions: {
        enabled: true,
        initialSortBy: null,
      },
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 5,
      },
    };
  },
  props: {
    titulo: {
      type: String,
      default: null,
    },
    subTitulo: {
      type: String,
      default: null,
    },
    acaoBtn: {
      type: String,
      default: null,
    },
    textoBtn: {
      type: String,
      default: null,
    },
    fields: {
      type: Array,
      required: true,
    },
    item: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true,
    },
    acaoBtnTwo: {
      type: String,
      default: null,
    },
    textoBtnTwo: {
      type: String,
      default: null,
    },
  },
  components: {
    VueGoodTable,
    Loading,
  },
  methods: {
    ...mapActions(["setLoading"]),
    dateRangeFilter(data, filterString) {
      let dateRange = filterString.split("to");
      let startDate = Date.parse(dateRange[0]);
      let endDate = Date.parse(dateRange[1]);
      return (data =
        Date.parse(data) >= startDate && Date.parse(data) <= endDate);
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },
    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },
    onSortChange(params) {
      localStorage.setItem(`${this.storageName}sortOptions`, JSON.stringify(params[0]))
      if (!params[0]) {
        return;
      }

      this.updateParams({
        sort: [
          {
            type: params[0].type,
            field: params[0].field,
          },
        ],
      });
    },
    getSortOptionOnStorage() {
      const sortStorage = localStorage.getItem(`${this.storageName}sortOptions`);
      if (sortStorage) this.sortOptions.initialSortBy = JSON.parse(sortStorage);
    },
    onColumnFilter(params) {
      this.updateParams(params);
    },
    refresh() {
    },
  },
  created() {
    this.storageName = this.titulo.replaceAll(' ', '');
    this.getSortOptionOnStorage();
  },
};
